import { render, staticRenderFns } from "./ProfileClientDialog.vue?vue&type=template&id=007556c6&"
import script from "./ProfileClientDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfileClientDialog.vue?vue&type=style&index=0&id=007556c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports